import config from '../../config/config';
import fetch from '../fetch';
import actions from './actions';

import { actions as recordActions } from '../records/actions.js'


const oauthRedirectUrl = process.env.REACT_APP_OAUTH_REDIRECT_URL
const oauthClientId = process.env.REACT_APP_OAUTH_CLIENT_ID
const medforgeUrl = process.env.REACT_APP_MEDFORGE_URL
const medforgeApiUrl = `${process.env.REACT_APP_MEDFORGE_URL}/api`
const mongoUrl = process.env.REACT_APP_BACKEND_URL
const oauthAuthorizationUrl = `${medforgeUrl}/#!/oauth?client_name=myEPAs`

/**
 * Redirect to OAuth authorization URI
 */
const authenticateWithMedforge = () => dispatch => {
  // TODO: we should use Auth Flow with PKCE when implemented in Passport
  window.location = `${oauthAuthorizationUrl}&response_type=token&client_id=${oauthClientId}&redirect_uri=${oauthRedirectUrl}&scope=&state=`
}

/**
 * Handles the redirect URI with an authorization_code and requests
 * an access_token.
 * @param {string} url OAuth redirect URI with code param
 */
const authenticateWithUrl = (url, authFlow) => dispatch => {
  if (!['token'].includes(authFlow)) {
    console.warn('Only token based authentication is currently supported')
    return
  }

  dispatch(actions.signInRequest())
  const accessToken = new URLSearchParams(new URL(url).hash.substring(1)).get('access_token')
  fetch(`${medforgeUrl}/api/user`, { headers: { authorization: `Bearer ${accessToken}` } })
    .then(response => response.json())
    .then(response => {
      const user = { ...response, accessToken: accessToken }
      dispatch(actions.signInSuccess(user))
    })
    .catch(err => dispatch(actions.signInFailure(err)))
}

/**
 * Request sign out from current device. Given token will be revoked.
 */
const signOut = () => (dispatch, getState) => {
  localStorage.removeItem(`${config.localStoragePrefix}user`)
  const user = getState().user.user
  const promise = user && user.accessToken ?
    fetch(`${mongoUrl}/logout`, {
      method: 'POST',
      headers: { authorization: 'Bearer ' + user.accessToken }
    })
    .then(_ => fetch(`${medforgeApiUrl}/logout`, {
      method: 'POST',
      headers: { authorization: 'Bearer ' + user.accessToken }
    })) :
    Promise.resolve()
  promise.finally(_ => dispatch(actions.reset()))
}

const setLang = lang => dispatch => {
  dispatch(actions.setLang(lang))
  dispatch(recordActions.setLang(lang))
}

const addMinimalPermission = () => (dispatch, getState) => {
  const user = getState().user.user
  const url = `${medforgeApiUrl}/user/add-minimal-mypeas-permission`
  dispatch(actions.miminalPermissionRequest())
  fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + user['accessToken']
    }
  })
    .then(response => response.json())
    .then(_ => {
      dispatch(actions.miminalPermissionSuccess())
    })
    .catch(err => dispatch(actions.miminalPermissionFailure(err)))
}

export default {
  setLang,
  signOut,
  addMinimalPermission,
  authenticateWithMedforge,
  authenticateWithUrl
}